import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";
import { PATH_AUTH } from "src/routes/paths";

const NoAccountSection = () => {
  const smUp = useResponsive("up", "sm");
  const { translate } = useLocales();

  return (
    !smUp && (
      <Typography variant="body2" align="center" sx={{ mt: 3 }}>
        {translate("auth.login.signupPrompt")}&nbsp;
        <Link
          variant="subtitle2"
          component={RouterLink}
          to={PATH_AUTH.register}
        >
          {translate("auth.login.getStarted")}
        </Link>
      </Typography>
    )
  );
};

export default NoAccountSection;
